import cx from 'classnames'
import * as React from 'react'

import { search } from '../../icons'
import type { SearchBarViewModel } from '../../view-models/SearchBarViewModel'
import type { ServiceMenuItemViewModel } from '../../view-models/ServiceMenuItemViewModel'
import type { ServiceMenuViewModel } from '../../view-models/ServiceMenuViewModel'
import Accordion from '../Accordion/Accordion'
import BaseButton from '../BaseButton/BaseButton'
import BaseModal from '../BaseModal/BaseModal'
import Icon from '../Icon/Icon'
import Link from '../Link/Link'
import SearchBar from '../SearchBar/SearchBar'
import ServiceMenuMobileLinks from '../ServiceMenuMobileLinks/ServiceMenuMobileLinks'
import styles from './serviceMenuMobile-style.css'

type Props = {
  serviceMenu: ServiceMenuViewModel
  searchBtn?: SearchBarViewModel
  isOpen?: boolean
  onSubmit?: (...args: Array<any>) => any
}

type State = {
  isSearchOpen: boolean
}

class ServiceMenuMobile extends React.Component<Props, State> {
  static displayName = 'ServiceMenuMobile'
  static defaultProps = {}
  state = {
    isSearchOpen: false,
  }
  handleSearchToggle = () => {
    this.setState({
      isSearchOpen: !this.state.isSearchOpen,
    })
  }

  renderItem(item: ServiceMenuItemViewModel, index: number) {
    if (item.links) {
      return (
        <Accordion
          key={index}
          className={styles.item}
          items={[
            {
              header: item.title,
              component: <ServiceMenuMobileLinks items={item.links} />,
            },
          ]}
        />
      )
    }

    if (item.link)
      return (
        <Link
          key={index}
          {...item.link}
          className={cx(styles.serviceMenuMobileItem, styles.item)}
          secondary
        >
          {(item.link && item.link.label) || item.title}
        </Link>
      )

    return null
  }

  render() {
    const { serviceMenu, searchBtn, isOpen, onSubmit } = this.props
    const { isSearchOpen } = this.state
    if (!serviceMenu || !serviceMenu.links) return null

    return (
      <div className={styles.serviceMenuMobile}>
        <div className={styles.menu}>
          {searchBtn && (
            <BaseButton className={styles.searchTrigger} onClick={this.handleSearchToggle}>
              <Icon iconSrc={search} width="14px" height="14px" className={styles.icon} />
              <span>{searchBtn.triggerText}</span>
            </BaseButton>
          )}
          {serviceMenu.links.map(this.renderItem)}
        </div>
        {isOpen && (
          <BaseModal isOpen={isSearchOpen}>
            <div className={cx(styles.searchComp, isSearchOpen ? styles.show : styles.hide)}>
              <SearchBar
                searchBtn={searchBtn}
                onSearchToggle={this.handleSearchToggle}
                onSubmit={onSubmit}
              />
            </div>
            <div
              className={cx(styles.searchOverlay, isSearchOpen && styles.show)}
              onClick={this.handleSearchToggle}
            />
          </BaseModal>
        )}
      </div>
    )
  }
}

export default ServiceMenuMobile